import React from 'react';
import { Button } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';

interface SendMessageButtonProps {
  alreadySent?: boolean;
  disabled?: boolean;
  onClick: () => void;
  type: 'category' | 'entry' | 'map';
  itemId: string | number;
}

function SendMessageButton({
  alreadySent = false,
  disabled = false,
  onClick,
  type,
  itemId,
}: SendMessageButtonProps) {
  function getTooltipMessage() {
    if (alreadySent) {
      switch (type) {
        case 'category':
          return 'Issue on this category already saved';
        case 'entry':
          return 'Issue on this variable already saved';
        default:
          return 'Issue on this map already saved';
      }
    }
    switch (type) {
      case 'category':
        return 'Notify the bulletin manager about an issue on this category';
      case 'entry':
        return 'Notify the bulletin manager about an issue on this variable';
      default:
        return 'Notify the bulletin manager about an issue on this map';
    }
  }

  return (
    <div data-tip={getTooltipMessage()} data-for={`flag-button-${itemId}`}>
      <Button
        variant="outline-primary"
        disabled={disabled || alreadySent}
        onClick={onClick}
        size="sm"
        data-cy="send-message-button"
        style={
          disabled || alreadySent
            ? {
                border: 'none',
              }
            : undefined
        }
      >
        {alreadySent ? 'Report saved' : 'Report an issue'}
      </Button>
      <ReactTooltip
        id={`flag-button-${itemId}`}
        effect="solid"
        className="smalltooltip"
        role="tooltip"
        disable={disabled}
      />
    </div>
  );
}

export default SendMessageButton;
